module.exports = __webpack_public_path__ + "img/card-text.579c38ba.svg";